<template>
  <div class="row" style="max-height: 100vh; overflow: auto;">
    <div v-for="m in filteredMedia" :key="m.id" class="col-xl-2 col-lg-3 col-md-3 col-sm-6 mt-2">
      <article v-if="m.type === 'folder'" class="card speaker hover-zoom shadow-lg media-3 rounded-top">
        <div class="card-body m-1" style="overflow: auto;">
          <span role="button" class="fw-semibold" @click="$emit('collection-folder-selected', m)">{{ m.title }}</span>
        </div>
        <div @click="$emit('collection-folder-selected', m)">
          <MediaThumbnail :media="m" />
        </div>
      </article>

      <article v-else :class="[m.type === 'file' ? 'p-2' : '']" class="card speaker hover-zoom shadow-lg media-3 rounded-top" style="height: 180px;">
        <div class="card-body p-0">
          <div class="" @click="navigate(m)">
            <MediaThumbnail :media="m" :isInCollection="true" :size="4" />
          </div>
          <div style="margin: 0.8rem 1rem;">
            <span role="button" class="fw-semibold" @click="navigate(m)">{{ m.title.slice(0,35) }}</span>
            <span v-if="m.title.length > 50">...</span>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
import MediaThumbnail from '@/components/commons/Media/Thumbnail.vue';

export default {
  components: {
    MediaThumbnail,
  },
  props: {
    media: {
      type: Array,
      default: null,
    },
    useEvent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filteredMedia() {
      return this.media.filter(m => m !== undefined && m !== null);
    }
  },
  methods: {
    navigate(media) {
      if (this.useEvent) {
        this.$emit('collection-media-selected', media);
      } else {
        this.$router.push('/media/' + media.slug);
      }
    },
  },
};
</script>
